import { render } from "./mped-amortization-move-main-asset-view.vue?vue&type=template&id=c4ad98f8"
import script from "./mped-amortization-move-main-asset-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-move-main-asset-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-move-main-asset-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4ad98f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4ad98f8', __exports__)) {
    api.reload('c4ad98f8', __exports__)
  }
  
  module.hot.accept("./mped-amortization-move-main-asset-view.vue?vue&type=template&id=c4ad98f8", () => {
    api.rerender('c4ad98f8', render)
  })

}


export default __exports__